import { executeRequest, JFSRequest } from '@jfs/network'
import { isSuccessResponse } from './../utils/index'
import { APIEndPoints } from './APIEndPoints'
import { getHeaders, getUrl, sitConfig } from './config'

const responseParser = (response: any) => {
  const data = isSuccessResponse(response)
  return data?.map((item: any) => ({
    id: item?.id,
    key: item?.key,
    merchantPayoutData: {
      //   type: 'bankingCode',
      //id: !isNaN(Number(item?.key)) ? Number(item?.key) : undefined,
      mid: item?.object?.entity?.entityId,
      frequencyId: '' + item?.object?.payoutConfig?.frequencyId,
      autoSettle: item?.object?.payoutConfig?.autoSettle === 0 ? false : true,
      autoSettleDays: '' + item?.object?.payoutConfig?.autoSettleDays ?? '',
      settlementOnHold: item?.object?.payoutConfig?.payoutSettleHold === 0 ? false : true,
      isDynamicSettlement: item?.object?.payoutConfig?.checker === 0 ? false : true,
      remarks: item?.object?.payoutConfig?.remarks ?? '',
    },
    data: {},
    type: item?.type,
    className: item?.className,
    username: item?.username,
    approvalStatus: item?.approvalStatus,
    approvalType: item?.approvalType,
  }))
}

const getMerchantPayoutPendingApprovals = (elevated: boolean, tokens: any) => {
  const request: JFSRequest<{}> = {
    apiPath: getUrl(APIEndPoints.riskControlMerchantPendingApprovals),
    method: 'GET',
    cache: false,
    config: sitConfig(tokens),
    headers: getHeaders(),
    body: {
      elevated,
      type: 'PAYOUT_CONFIG',
    },
  }

  return executeRequest(request)
    .then(responseParser)
    .catch((error) => {
      throw error
    })
}

export { getMerchantPayoutPendingApprovals }
